export const AboutPage: React.FC<any> = (props) => {
    return (<>
        <p><b>clist-ex</b> is an extension based on the great website <a href="https://clist.by/" target="_blank">clist.by</a>.</p>
        <p>It adds contest dashboard for LeetCode and CodeChef, which is inspired by <a href="https://cftracker.netlify.app/" target="_blank">https://cftracker.netlify.app/</a> and <a href="https://kenkoooo.com/atcoder#/" target="_blank">https://kenkoooo.com/atcoder#/</a>.</p>
    </>);
}
